<template>
  <div>
    <div class="page-title">Announcements from {{siteName}}</div>
    <section>
      <div class="announcement-item" v-for="item in announcements">
        <div class="posted-date">Posted {{getFormatedDate(item.postedDate)}}</div>
        <div class="title"><span v-if="item.titlePrefix">{{item.titlePrefix}}: </span>{{item.title}}</div>
        <div class="description">{{item.description}}</div>
        <div class="" v-if="item.url"><a :href="item.url">{{item.url}}</a></div>
      </div>
    </section>

    <title-block title="Trending Keywords" link-title="View All" link-name="" color-theme="primary-color">
      <div>
      </div>
    </title-block>

    <title-block title="Trending Popular Articles" link-title="View All" link-name="" color-theme="primary-color">
      <div>
        <condensed-issue v-for="(issue, index) in issues" v-if="index<3" :key="issue.id" v-bind:issue="issue"></condensed-issue>
      </div>
    </title-block>


    <title-block :title="`Top 5 ${siteName} Papers Rated by Altmetric Attention Score`" link-title="View All" link-name="" color-theme="primary-color">
      <div>
        <condensed-issue v-for="(issue, index) in issues" v-if="index<5" :key="issue.id" v-bind:issue="issue"></condensed-issue>
      </div>
    </title-block>

    <title-block title="Google Mention Alert"  color-theme="primary-color">
      <div>
      </div>
    </title-block>

    <title-block title="Social Feeds" color-theme="primary-color">
      <div>
      </div>
    </title-block>

  </div>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'announcements',
    mixins: [ UtilityMixin ],
    components: {
      TitleBlock,
      CondensedIssue
    },
    data () {
      return {
        siteName: process.env.SITE_NAME,
        issues: [],
        announcements: [
          {
            postedDate: new Date(Date.now()),
            title: 'September 24-26, 2016',
            titlePrefix: 'Upcoming Event',
            description: 'Oncotarget journal is a Sponsor of Rare Cells in Circulation Gordon Research Conference, South Hadley, MA.',
            url: 'http://www.grc.org/programs.aspx?id=16786'
          },
          {
            postedDate: new Date('2016-02-09'),
            title: 'August 7-12, 2016',
            titlePrefix: 'Upcoming Event',
            description: 'Oncotarget journal is a Sponsor of Rare Cells in Circulation Gordon Research Conference, South Hadley, MA.',
            url: 'http://www.grc.org/programs.aspx?id=16786'
          },
          {
            postedDate: new Date('2015-02-09'),
            title: 'Starting August 2015, Oncotarget goes weekly',
            description: 'Our mission is to make scientific results rapidly and widely available. To maximize the impact of research via insightful review. To allow exceptional discoveries to be shared quickly. To eliminate the border between specialties. To link different fields of biomedical science. To foster applications of basic and clinical science to fight disease.'
          }
        ]
      }
    },
    created () {
      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.issues = response.body.articles
      }, function () {
      })
    }
  }
</script>


<style lang="scss" scoped>
  section {
    margin-top: $spacing-extra-large;
  }
  .announcement-item {
    padding-bottom: $spacing-large;
    margin-bottom: $spacing-large;
    border-bottom: 1px solid $devider;
    .posted-date {
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      font-style: italic;
      line-height: 1.42;
      text-align: left;
      color: $black;
      opacity: 0.6;
      margin-bottom: 7.5px;
    }
    .title {
      font-family: 'Merriweather';
      font-style: italic;
      color: $primary-color;
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 7.5px;
      span {
        font-weight: 300;
        color: $accent-color-3;
      }
    }
    .description {
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      line-height: 1.38;
      text-align: justify;
      color: $accent-color-3;
    }
  }
</style>



// WEBPACK FOOTER //
// AnnouncementsPage.vue?2fe97af6